import styled from '@emotion/styled';
import { Card, Divider, Flex } from 'antd';

export const Wrapper = styled(Flex)`
  width: 100%;
`;

export const RecipientCard = styled(Card)`
  .ant-card-body {
    padding-top: 16px;
  }
`;

export const RecipientDivider = styled(Divider)`
  margin: 16px 0;
`;

/** One line under the audience toggle spelling out who the current pool is. */
export const AudienceHint = styled.p`
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const Header = styled(Flex)`
  width: 100%;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.black};
`;

export const Subtitle = styled.span`
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark};
  max-width: 60ch;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 320px;
  gap: 20px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Side = styled(Flex)`
  width: 100%;
`;

export const SumRow = styled(Flex)`
  width: 100%;
  padding: 8px 0;

  & + & {
    border-top: 1px dashed ${({ theme }) => theme.colors.borderSecondary};
  }
`;

export const SumLabel = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const SumValue = styled.span<{ accent?: boolean }>`
  font-size: 22px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${({ theme, accent }) => (accent ? theme.colors.link : theme.colors.black)};
`;

export const SumValueMuted = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray};
`;

export const Hint = styled.p`
  margin: 10px 0 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.gray};
`;
